import { IconExclamationCircle, IconExternalLink } from "@tabler/icons-react";
import Text from "../../UI/Text";
import Callout from "../../UI/Callout";
// @ts-expect-error pure js
import Spinner from "../../UI/Spinner.jsx";
import styles from "./BulkPdfPreview.module.css";

interface BulkPdfPreviewProps {
  iframeTitle: string;
  hasSelection: boolean;
  isIneligible: boolean;
  ineligibleTitle: string;
  ineligibleReason?: string;
  previewUrl?: string;
  previewLoading: boolean;
  previewError?: string;
  noSelectionMessage?: string;
}

export default function BulkPdfPreview({
  iframeTitle,
  hasSelection,
  isIneligible,
  ineligibleTitle,
  ineligibleReason,
  previewUrl,
  previewLoading,
  previewError,
  noSelectionMessage = "Sélectionnez un locataire pour afficher l'aperçu.",
}: BulkPdfPreviewProps) {
  return (
    <div className={styles.preview}>
      {isIneligible ? (
        <div className={styles.previewEmpty}>
          <IconExclamationCircle
            size={48}
            className={styles.previewEmptyIcon}
          />
          <Text weight="bold">{ineligibleTitle}</Text>
          <Text>{ineligibleReason}</Text>
          <Text>Vous pouvez le retirer de la sélection avec la croix.</Text>
        </div>
      ) : (
        <>
          {previewLoading && (
            <div className={styles.previewState}>
              <Spinner width="3em" />
            </div>
          )}
          {!previewLoading && (
            <Callout variant="danger">{previewError}</Callout>
          )}
          {!previewLoading && !previewError && previewUrl && (
            <div className={styles.previewContent}>
              <a
                href={previewUrl}
                target="_blank"
                rel="noreferrer"
                className={styles.openInNewTab}
              >
                <IconExternalLink size={16} />
                Ouvrir dans un nouvel onglet
              </a>
              <iframe
                src={`${previewUrl}#toolbar=0&navpanes=0&view=Fit`}
                title={iframeTitle}
                className={styles.previewFrame}
              />
            </div>
          )}
          {!previewLoading && !previewError && !previewUrl && !hasSelection && (
            <div className={styles.previewState}>
              <Text color="muted">{noSelectionMessage}</Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
